<div class="backRouter py-4 cursor-pointer" (click)="goBack()">
  <a>
    <i class="pi pi-chevron-circle-left vertical-align-bottom"> </i>
    <span>Voltar</span>
  </a>
</div>

